/**
 * RISK-FAMILY-OVERVIEW
 * Dashboard for the risk
 */
import { useAppSelector } from "@/core/root-reducer"
import { FadeIn } from "@/utils/animations.utils"
import riskFamilyStore from "../model/risk-family.store"
import { PhysicalRiskMeter } from "@/entities/physical-risk/ui/PhysicalRiskMeter"
import DashboardNumber from "@/components/dashboard-number"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import PhysicalRiskCard from "@/entities/physical-risk/ui/PhysicalRiskCard"
import useOpenPhysicalRiskFromQuery from "@/entities/physical-risk/hooks/useOpenPhysicalRiskFromQuery"
import { RISK_FAMILY_UNDEFINED_ID } from "../model/risk-family.types"
import PageHeader from "@/components/page-header"
import { getRiskFamilyImageUrl } from "../model/risk-family.utils"

export default function RiskFamilyOverview() {
  const riskFamily = useAppSelector(riskFamilyStore.selectors.active)
  const riskMax = useAppSelector((state) => physicalRiskStore.selectors.maxForFamily(state, riskFamily.id))
  const risks = useAppSelector(physicalRiskStore.selectors.listFilteredForFamily)
  const isIdtreeScoreHidden = useAppSelector((state) => state._session.accountRisksSettings.isIdtreeScoreHidden)
  const isUndefinedFamily = riskFamily.id === RISK_FAMILY_UNDEFINED_ID
  const imageUrl = getRiskFamilyImageUrl(riskFamily)

  useOpenPhysicalRiskFromQuery(risks)

  return (
    <FadeIn className="box-border h-full overflow-y-auto px-40 pb-80 pt-20">
      <div className="overview-header grid grid-cols-[minmax(0,1fr)_140px] items-start gap-40">
        <div>
          <PageHeader section="Risques" title={riskFamily.name} />
          <div className="flex items-center">
            {riskMax && (
              <div className="flex">
                <div className="my-auto mr-20">
                  <PhysicalRiskMeter risk={riskMax} size="lg" />
                </div>
                {!isIdtreeScoreHidden && (
                  <div className="w-[150px]">
                    <DashboardNumber
                      color={riskMax.cValueEffectiveColor ?? undefined}
                      count={riskMax.cValueEffectiveLabel}
                      header="Risque résiduel"
                      fontSize={18}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-start">
          {!isUndefinedFamily && imageUrl && (
            <div className="flex h-[86px] w-[130px] bg-white p-8" style={{ borderRadius: 12 }}>
              <img
                className="m-auto max-h-full max-w-full object-contain"
                alt={riskFamily.code || riskFamily.name}
                src={imageUrl}
                onError={(e) => (e.currentTarget.style.display = "none")}
              />
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-wrap">
        {risks.map((risk) => {
          return <PhysicalRiskCard key={risk.id} risk={risk} />
        })}
      </div>

      {risks.length === 0 && <div className="grey-t mt-20">Aucun risque ne correspond aux critères de recherche.</div>}
    </FadeIn>
  )
}
